var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-field", [
    _c(
      "div",
      { staticClass: "row no-wrap" },
      [
        _c(
          "q-input",
          _vm._b(
            {
              staticClass: "col no-shadow",
              attrs: {
                name: "discount",
                value: _vm._f("asDecimal")(
                  _vm.discountValue,
                  _vm.isAbsoluteDiscount
                ),
                type: "number",
                placeholder: _vm.$t("discount")
              },
              on: { input: _vm.handleDiscountUpdate }
            },
            "q-input",
            _vm.$attrs,
            false
          )
        ),
        _c(
          "q-btn-dropdown",
          {
            staticStyle: { "margin-top": "9px" },
            attrs: {
              flat: "",
              dense: "",
              label: _vm.isAbsoluteDiscount ? _vm.currencySymbol : "%"
            }
          },
          [
            _c(
              "q-list",
              { attrs: { link: "" } },
              [
                _c(
                  "q-item",
                  {
                    directives: [
                      { name: "close-overlay", rawName: "v-close-overlay" }
                    ],
                    nativeOn: {
                      click: function($event) {
                        _vm.handleChangeDiscountType("abs")
                      }
                    }
                  },
                  [
                    _c("q-item-side", {
                      attrs: { letter: _vm.currencySymbol }
                    }),
                    _c(
                      "q-item-main",
                      [
                        _c("q-item-tile", { attrs: { label: "" } }, [
                          _vm._v(_vm._s(_vm.$t("absolute")))
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "q-item",
                  {
                    directives: [
                      { name: "close-overlay", rawName: "v-close-overlay" }
                    ],
                    nativeOn: {
                      click: function($event) {
                        _vm.handleChangeDiscountType("rel")
                      }
                    }
                  },
                  [
                    _c("q-item-side", { attrs: { letter: "%" } }),
                    _c(
                      "q-item-main",
                      [
                        _c("q-item-tile", { attrs: { label: "" } }, [
                          _vm._v(_vm._s(_vm.$t("relative")))
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }